import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getChainImg } from '@shared/types/wallet-chain.type';
import { ChainEnum } from '@src/app/shared/types/wallet-chain.type';
import { getAge } from '@src/app/shared/utils/common.util';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { MemeDashboardService } from '../../meme-dashboard.service';
import { MemeTokenProfile } from '../../meme-dashboard.type';
import { environment } from '@src/environments/environment';
dayjs.extend(isSameOrBefore);
@Component({
    selector: 'app-token-detail',
    templateUrl: './token-detail.component.html',
    styleUrls: ['./token-detail.component.less'],
})
export class TokenDetailComponent implements OnInit {
    getChainImg = getChainImg;
    ChainEnum = ChainEnum;

    address: string;
    chainName: ChainEnum | 'monad_testnet';
    tokenInfo: MemeTokenProfile;
    age: string;
    top10Percentage = 0;

    get viewAllHolderLink() {
        if (this.chainName === ChainEnum.BASE) {
            return `https://basescan.org/token/${this.address}#balances`;
        }

        if (this.chainName === ChainEnum.SOL) {
            return `https://solscan.io/token/${this.address}#holders`;
        }

        if (this.chainName === ChainEnum.BSC) {
            return `https://bscscan.com/token/${this.address}#balances`;
        }

        if (this.chainName === 'monad_testnet') {
            return `https://monad-testnet.socialscan.io/token/${this.address}#balances`;
        }

        return '';
    }

    get viewAllTxLink() {
        if (this.chainName === ChainEnum.BASE) {
            return `https://basescan.org/token/${this.address}`;
        }

        if (this.chainName === ChainEnum.BSC) {
            return `https://bscscan.com/token/${this.address}`;
        }

        if (this.chainName === ChainEnum.SOL) {
            return `https://solscan.io/token/${this.address}`;
        }

        if (this.chainName === 'monad_testnet') {
            return `https://monad-testnet.socialscan.io/token/${this.address}`;
        }

        return '';
    }

    constructor(private activateRoute: ActivatedRoute, private memeDashboardService: MemeDashboardService) {}

    ngOnInit() {
        this.address = this.activateRoute.snapshot.params['address'];
        this.chainName = this.activateRoute.snapshot.params['chain_name'];

        this.memeDashboardService.getTokenDetail(this.chainName, this.address).then(data => {
            this.tokenInfo = data;

            this.age = getAge(data.token_created_at);
        });
    }

    goToBuy() {
        let chainName = this.chainName;
        if (chainName === 'monad_testnet') {
            chainName = 'mt' as any;
        }

        window.open(`${environment.telegram.botLink}?start=ex_trading_${chainName}_${this.address}`, '_blank');
    }
}
